import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import { AuthSate, RankingMasterInformation, UserTypes } from 'models';

export interface LoginPayload {
  email: string;
  password: string;
  role?: number;
  remember_me?: boolean;
}

export interface LogoutPayload {
  token: string;
  notification_token: string;
}

const initialState: AuthSate = {
  isLoggedIn: false,
  logging: false,
  currentUser: {},
  isFoodField: localStorage.getItem('POS_DAILY_FOOD_FIELD')
    ? localStorage.getItem('POS_DAILY_FOOD_FIELD') === 'true'
    : null,
  masterInfoLoading: true,
  masterInfo: localStorage.getItem('masterInfo')
    ? JSON.parse(localStorage.getItem('masterInfo')!)
    : ({} as RankingMasterInformation),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, action: PayloadAction<{ state: LoginPayload }>) {
      state.logging = true;
    },

    loginSuccess(state, action: PayloadAction<UserTypes>) {
      state.isLoggedIn = true;
      state.logging = false;
      state.currentUser = action.payload;
    },

    logout(
      state,
      action: PayloadAction<{ token: string; params: { notification_token: string } }>
    ) { },
    logoutSuccess(state) {
      Cookies.remove('POS_CUSTOMER_PAYMENT_TOKEN');
      localStorage.removeItem('POS_CUSTOMER_PAYMENT_SELECTED_SHOP');
      localStorage.removeItem('POS_DAILY_USER_ID');
      localStorage.removeItem('POS_DAILY_FOOD_FIELD');
      localStorage.removeItem('ID_SELECTED_SHOP');
      localStorage.removeItem('SELECTED_SHOP_ID');
      localStorage.removeItem('selectedShop');
      localStorage.removeItem('shopSetting');
      localStorage.removeItem('masterInfo');
      localStorage.removeItem('dataDateRankNearest');
      localStorage.removeItem('dataDateRank');
      localStorage.removeItem('dataMonthRank');
      localStorage.removeItem('dataDateRankGroupShop');
      localStorage.removeItem('dataMonthRankGroupShop');
      state.currentUser = {};
      state.isLoggedIn = false;
      state.currentUser = undefined;
      state.isFoodField = null;
    },

    setFoodField(state, action: PayloadAction<boolean>) {
      state.isFoodField = action.payload;
      localStorage.setItem('POS_DAILY_FOOD_FIELD', action.payload.toString());
    },
    getMasterPermission(state, action: PayloadAction<{ token: string }>) {
      state.masterInfoLoading = true;
    },
    getMasterPermissionSuccess(state, action: PayloadAction<RankingMasterInformation>) {
      state.masterInfoLoading = false;
      state.masterInfo = action.payload;
      if (Object.values(action.payload).length) {
        localStorage.setItem('masterInfo', JSON.stringify(action.payload));
      }
    },
    getMasterPermissionFailed(state) {
      state.masterInfoLoading = false;
    },
    resetMasterPermission(state) {
      state.masterInfo = initialState.masterInfo;
    },
  },
});

// Actions
export const authActions = authSlice.actions;

// Selectors
export const selectLoginUser = (state: any) => state.auth;
// Reducer
const authReducer = authSlice.reducer;
export default authReducer;
